import {
  setActiveInst,
  setDataInst,
  setErrorInst,
  setLoadingInst,
  setNewInst,
  setUpdateInst,
} from "../../../../store/slices/integrationSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

// Получение статуса инита
export const getInitInstInstance = (username, userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/instagram/client?userId=${userId}&username=${username}`
      );

      if (data.code === 200) {
        console.log("getInitInstInstance", data?.instance?.initState);
      } else {
        errorToast("Ошибка получения данных инициализации Instagram");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        errorToast("Произошла ошибка: " + error.message);
      }

      console.error("getInitInstInstance error:", error);
    }
  };
};

// Инит инстаграм
export const initInst = (
  userData,
  setStep,
  setLoading,
  setIsInstagramConnected,
  setError,
  navigate,
  closeModal
) => {
  return (dispatch) => {
    setLoading(true);

    const requestData = {
      userId: userData.userId,
      username: userData.userName,
      password: userData.password,
      // code: userData?.code,
    };

    $authHost
      .post(`/integrations/instagram/initialization`, requestData)
      .then((response) => {
        const { code, message } = response.data;

        if (code === 200) {
          if (message === "OK") {
            setIsInstagramConnected(true);
            setLoading(false);
            navigate("/integration");
            setStep(2);
            dispatch(setNewInst(null));
            dispatch(getInstagramIntegrations(requestData?.userId));
            return;
          } else if (message === "client exist") {
            errorToast("Пользователь уже подключен");
            setLoading(false);
            setTimeout(() => {
              closeModal();
              setIsInstagramConnected(false);
              navigate("/integration");
              dispatch(setNewInst(null));
              dispatch(getInstagramIntegrations(requestData?.userId));
            }, 4000);
          }
        }

        if (message) {
          handleErrorMessages(message, setError);
        }
      })
      .catch((error) => {
        setLoading(false);

        console.error(
          "Error in initInst:",
          error.response?.data?.message || error.message
        );

        if (error.response) {
          // Обработка ошибок на основе кода ответа
          if (error.response.status === 401) {
            dispatch(removeUser());
          } else if (error.response.status === 500) {
            if (
              error.response.data.message === "error: password is incorrect"
            ) {
              setError("Неверный пароль, повторите попытку");
            } else {
              errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
            }
          }
        } else if (error.request) {
          // Ошибка связи с сервером
          errorToast(
            "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
          );
        } else {
          // Ошибка на уровне запроса или внутренней логики
          errorToast("Произошла ошибка: " + error.message);
        }

        handleErrors(error, setError);
      });
  };
};

const handleErrorMessages = (message, setError) => {
  if (message === "incorrect code") {
    setError("Неверный код, повторите попытку");
  }
  if (message === "incorrect phone") {
    setError("Ошибка Telegram, повторите попытку позже");
  }
  if (message === "incorrect password") {
    setError("Неверный пароль, повторите попытку");
  }
};
// Функция для обработки ошибок
const handleErrors = (error, setError) => {
  const errorMessage = error.response?.data?.message;

  if (errorMessage === "incorrect type") {
    localStorage.setItem(
      "typeTelegramInit",
      error.response?.data?.expectedType
    );
  }
  if (errorMessage === "incorrect code") {
    setError("Неверный код, повторите попытку");
  }
  if (errorMessage === "incorrect phone") {
    setError("Ошибка Telegram, повторите попытку позже");
  }
  if (errorMessage === "incorrect password") {
    setError("Неверный пароль, повторите попытку");
  }
};

// Получение списка интеграций
export const getInstagramIntegrations = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/instagram/list?userId=${userId}`
      );
      // console.log("data inst", data);
      if (data.code === 200) {
        dispatch(setDataInst(data.users));
      } else {
        errorToast("Произошла ошибка получения интеграций Instagram");
      }
    } catch (error) {
      console.error("Error in getInstagramIntegrations:", error);

      if (error.response) {
        // Обработка ошибок на основе кода ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast(`Произошла ошибка: ${error.message}`);
      }
    }
  };
};

// Получение конкретной интеграции
export const getInstagramIntegration = (userId, externalInstagramId) => {
  return async (dispatch) => {
    dispatch(setLoadingInst(true));
    dispatch(setErrorInst(false));

    try {
      const { data } = await $authHost.get(
        `/integrations/instagram?userId=${userId}&externalInstagramId=${externalInstagramId}`
      );
      if (data.code === 200) {
        dispatch(setLoadingInst(false));
        // console.log("data inst integration", data);
        localStorage.setItem("dataInst", JSON.stringify(data.user));
        dispatch(setActiveInst(data.user));
      } else {
        dispatch(setErrorInst(true));
      }
    } catch (error) {
      dispatch(setLoadingInst(false));
      dispatch(setErrorInst(true));
      console.error("Error in getInstagramIntegration:", error);

      if (error.response) {
        // Обработка ошибок на основе кода ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
          errorToast("Вы не авторизованы. Пожалуйста, войдите снова.");
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast(`Произошла ошибка: ${error.message}`);
      }
    }
  };
};

// Настройка инсты
export const configureInstagramClient = (
  configuration,
  externalInstagramId
) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/instagram/client`,
        configuration
      );

      if (data) {
        dispatch(getInstagramIntegration(userId, externalInstagramId));
      }

      if (data.code === 200) {
        dispatch(setUpdateInst(false));
      } else {
        errorToast("Произошла ошибка");
      }
      // console.log("configureInstagramClient", data);
    } catch (error) {
      console.error("Error in configureInstagramClient:", error);

      if (error.response) {
        // Обработка ошибок на основе кода ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast(`Произошла ошибка: ${error.message}`);
      }
    }
  };
};

// Деактивация инсты
export const deactivateInstagram = (dataDeactivation, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/instagram/deactivation`,
        dataDeactivation
      );

      if (data.code === 200) {
        // console.log("deactivateTelegram", data);
        localStorage.removeItem("dataInst");
        setLoading(false);
        dispatch(setActiveInst(null));
        dispatch(getInstagramIntegrations(dataDeactivation.userId));
        navigate("/integration");
      } else {
        errorToast("Ошибка деактивации");
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        // Обработка ошибок на основе кода ответа
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка на сервере. Пожалуйста, попробуйте позже.");
        }
      } else if (error.request) {
        // Ошибка связи с сервером
        errorToast(
          "Ошибка связи с сервером. Пожалуйста, проверьте подключение."
        );
      } else {
        // Ошибка на уровне запроса или внутренней логики
        errorToast(`Произошла ошибка: ${error.message}`);
      }

      console.error("deactivateInstagram error:", error);
    }
  };
};
